import $ from 'jquery'
import 'jquery.cookie'

$.cookie.defaults.path = '/'
